import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TimetrackSelectors, TimetrackDispatchers, SessionSelectors, AuthSelectors } from '@store';
import { IndexCard } from '@store/models';
import { switchMap } from 'rxjs/operators';

@Component({
    selector: 'app-timetrack-modal',
    template: `
        <app-timetrack-modal-ui
            [lev]="lev$ | async"
            [step]="step$ | async"
            [user]="userCard$ | async"
            [users]="userCards$ | async"
            [selectedYear]="year$ | async"
            [selectedWeek]="week$ | async"
            [selectedDate]="date$ | async"
            [searchFor]="searchFor$ | async"
            (selectStep)="selectStep($event)"
            (selectUser)="selectUser($event)"
            (selectYear)="selectYear($event)"
            (selectWeek)="selectWeek($event)"
            (selectDate)="selectDate($event)"
            (selectToday)="selectToday()"
            (search)="search($event)"
        ></app-timetrack-modal-ui>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TimetrackModalContainer implements OnInit {
    lev$ = this.authSelector.userLev$;
    step$ = this.timetrackSelector.step$;
    userCard$ = this.timetrackSelector.user$;
    year$ = this.timetrackSelector.year$;
    week$ = this.timetrackSelector.week$;
    date$ = this.timetrackSelector.date$;
    userCards$ = this.year$.pipe(
        switchMap(year => this.sessionSelector.usersSA$(new Date(year, 0, 1)))
    );
    searchFor$ = this.timetrackSelector.searchFor$;

    constructor(
        private timetrackDispatch: TimetrackDispatchers,
        private timetrackSelector: TimetrackSelectors,
        private sessionSelector: SessionSelectors,
        private authSelector: AuthSelectors
    ) {}

    ngOnInit() {
        this.selectUser(null);
        this.timetrackDispatch.searchActiveClient();
    }

    selectStep(step: number) {
        this.timetrackDispatch.selectStep(step);
    }

    selectUser(user: IndexCard | null) {
        this.timetrackDispatch.selectUser(user);
    }

    selectYear(year: number) {
        this.timetrackDispatch.selectYear(year);
    }

    selectWeek(week: number) {
        this.timetrackDispatch.selectWeek(week);
    }

    selectDate(date: Date) {
        this.timetrackDispatch.selectDate(date);
    }

    selectToday() {
        this.timetrackDispatch.selectToday();
    }

    search(searchFor: string) {
        this.timetrackDispatch.search(searchFor);
    }

}
